import {
  Box,
  Typography,
  Switch,
  Grid,
  Card,
  Divider,
  Link,
  FormControlLabel,
  Checkbox,
  Button,
} from "@mui/material";
import { useState } from "react";
import { useSelector } from "react-redux";

const AccountDetails = () => {
  const user = useSelector((state) => state.user.profile);

  return (
    <div className="space-y-6">
      {/* Login Section */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6">
        <h2 className="text-2xl font-bold text-slate-100 mb-6">Login</h2>

        <div className="grid grid-cols-[160px_1fr_auto] items-center gap-4 py-4">
          <span className="font-medium text-slate-200">Email</span>
          <Typography className="text-slate-400">
            {user?.email || "-"}
          </Typography>

          {/* <Button
            variant="contained"
            sx={{
              textTransform: "none",
              fontSize: "14px",
              bgcolor: "#000",
              "&:hover": { bgcolor: "#000" },
            }}
          >
            Change
          </Button> */}
        </div>

        {/* <Divider />

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "160px 1fr auto",
            alignItems: "center",
            py: 2,
          }}
        >
          <Typography fontWeight={500}>Password</Typography>

          <Typography color="#374151">{user?.email || "-"}</Typography>

          <Button
            variant="contained"
            sx={{
              textTransform: "none",
              fontSize: "14px",
              bgcolor: "#000",
              "&:hover": { bgcolor: "#000" },
            }}
          >
            Change
          </Button>
        </Box> */}
      </div>

      {/* Delete Account */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6">
        <h2 className="text-2xl font-bold text-slate-100 mb-6">Delete Account</h2>

        <div className="grid grid-cols-[160px_1fr_auto] items-center gap-4 py-4">
          <span className="font-medium text-slate-200">Delete Account</span>
          <span className="text-slate-400">
            Permanently delete my account. This action cannot be undone.
          </span>
          <button className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors">
            Delete
          </button>
        </div>
      </div>

    </div>
  );
};


export default AccountDetails;
